/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

import { Text, BoldText, RegularText } from '../../components/common/Text';
import { getConsultationSummary, openFileViewer } from '../../actions/index';
import LoadingComponent from '../../components/common/LoadingComponent';
import StyledTappable from '../../components/common/StyledTappable';
import { fontSize } from '../../utils';

import noCasefileIcon from '../../images/consultations/nocasefile.svg';
import downloadIcon from '../../images/download.svg';
import labsIcon from '../../images/home/lab.png';
import medicine from '../../images/medicine.svg';
import diagnostics from '../../images/diagnostics.svg';
import pdfIcon from '../../images/pdf.svg';

const OuterContainer = styled.div`
  background: white;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  padding-bottom: 16px;
`;

const EmptyContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 2rem;
  padding-top: 6rem;
`;

const EmptyIcon = styled.img`
  width: 9rem;
  margin-bottom: 2rem;
`;

const EmptyTitle = styled(BoldText)`
  opacity: 0.5;
  margin-bottom: 1rem;
`;

const EmptySubtitle = styled(RegularText)`
  font-size: 0.875rem;
  opacity: 0.5;
  font-weight: 500;
  max-width: 300px;
`;

const CategoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  background: #ffffff;
  border: 1px solid #e3e3e3;
  border-radius: 12px;
  margin: 25px 24px 0px 24px;
`;

const CategoryTitle = styled(BoldText)`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  padding: 15px 0px 15px 16px;
  border-bottom: 1px solid #f0f3f6;

  color: #0f0b28;
`;

const SymptomContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: 16px;
  margin-left: 16px;
`;

const MedicineContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: 16px;
`;

const SymptomIcon = styled.img`
  width: 20px;
  height: 20px;
`;

const SymptomText = styled(Text)`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #0f0b28;
`;

const LabTestText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #0f0b28;
  margin-left: 8px;
`;

const SymptomSubTitle = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #0f0b28;
`;

const SymptomTagsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-left: 8px;
`;

const GeneralAdviceTextContainter = styled.div`
  margin: 0px 17px 14px 17px;
`;

const GenralAdvicePoint = styled.p`
  font-style: normal;
  font-weight: 400;
  margin-top: ${(props) => (props.isFirst ? '7px' : '12px')};
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.5px;
  color: #0f0b28;
`;
const SymptomTag = styled(RegularText)`
  font-style: normal;
  font-weight: 400;
  word-break: initial;
  width: 95%;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.5px;
  color: #767787;
`;

const AttachmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  align-items: center;
  flex-shrink: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 1rem;
`;

const AttachmentItemContainer = styled(StyledTappable)`
  background: #f5f4ff;
  border-radius: 12px;
  margin: 16px 16px 0px 16px;
  display: flex;
  align-self: start;
  padding: 13px 12px;
`;
const AttachmentImgIcon = styled.div`
  color: #8852cc;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-image: ${(props) => `url(${props.src})`};
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 13px;
`;

const AttachmentTextContainer = styled.div`
  display: flex;
  margin-left: 8px;
  flex: 1 0 auto;
  flex-direction: column;
`;

const AttachmentName = styled(BoldText)`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #0f0b28;
`;

const AttachmentDate = styled(Text)`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 150%;
  letter-spacing: 0.25px;
  color: #767787;
`;

const PrescriptionHeader = styled.div`
  display: flex;

  margin-top: 18px;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f3f6;
`;

const PrescriptionTitle = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

const ArrowUp = styled(FaChevronUp)`
  font-size: ${() => fontSize(0.625)};
  width: 0.75rem;
  margin-right: 0.75rem;
  color: var(--primary-button);
`;

const ArrowDown = styled(FaChevronDown)`
  font-size: ${() => fontSize(0.625)};
  width: 0.75rem;
  margin-right: 0.75rem;
  color: var(--primary-button);
`;

const PrescriptionTitleContainer = styled(StyledTappable)`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
`;

const PrescriptionTitleText = styled(BoldText)`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  margin-left: 16px;
  margin-bottom: 16px;
  color: #0f0b28;
`;

const DownloadContainer = styled(StyledTappable)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 16px;
  color: #6544c6;
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
`;

const DownloadIcon = styled.img`
  width: 16px;
  height: 16px;
  color: #6544c6;
`;

const MedicineHeader = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  text-transform: uppercase;
  margin-bottom: 5px;
  border-top: ${(props) => (props.isBorderVisibile ? '1px solid #F0F3F6' : '')};
  padding-top: 16px;
  color: #767787;
`;

const GenralAdviceHeader = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  padding-left: 17px;
  margin-top: 18px;
  padding-bottom: 17px;
  border-bottom: 1px solid #e3e3e3;
  line-height: 150%;
  color: #0f0b28;
`;

const DetailHeaderText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  text-transform: uppercase;
  margin-left: 16px;
  margin-top: 18px;
  color: #767787;
`;

const DownloadText = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  color: var(--primary-button);
  margin-right: 8px;
`;
const ShowLessContainer = styled.div`
  margin-top: 24px;
  border-top: 1px solid #f0f3f6;
  padding-top: 16px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  padding-bottom: 16px;
  line-height: 150%;
  justify-content: center;
  display: flex;
  align-items: center;
  letter-spacing: 0.25px;
  color: var(--primary-button);
`;
const GeneralAdviceContainer = styled.div`
  background: #f0f3f6;
  border-radius: 12px;
  margin: 19px 24px 0 24px;
`;
class ConsultationSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openPrescription: 0,
      prescriptionLink: '',
    };
  }

  componentDidMount = () => {
    this.getConsultationSummary();
  };

  getConsultationSummary() {
    this.props.getConsultationSummary();
  }
  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.setState({
      showUploadOption: false,
    });
    setTimeout(this.props.hideModal, 200);
  };
  render() {
    const { consultationSummary } = this.props;

    const renderSymptom = (ele, idx) => {
      const renderSymptomTag = (tag, tagIdx) => (
        <SymptomTag key={tagIdx}>{tag}</SymptomTag>
      );
      return (
        <SymptomContainer key={idx}>
          <SymptomIcon src={diagnostics} />
          <SymptomTagsContainer>
            <SymptomSubTitle>{ele.title}</SymptomSubTitle>
            {ele.tags.map(renderSymptomTag)}
          </SymptomTagsContainer>
        </SymptomContainer>
      );
    };
    const renderAttachment = (ele, idx) => {
      const { fileName, fileType, fileUrl, uploadedOn } = ele;
      return (
        <AttachmentItemContainer
          key={idx}
          onTap={() => {
            try {
              const userAgent = navigator.userAgent || navigator.vendor;
              if (window.Android) {
                return window.open(fileUrl, '_blank');
              } else if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    method: 'openUrl',
                    link: fileUrl,
                  })
                );
              }
              // else if (sponsorId === 33 || sponsorId === 134) {
              else if (/iPad|iPhone|iPod/.test(userAgent)) {
                const anchor = document.createElement('a');
                anchor.setAttribute(
                  'href',
                  `didtap://${encodeURIComponent(fileUrl)}`
                );
                anchor.click();
                return;
              } else {
                this.props.openFileViewer({
                  contentUrl: fileUrl,
                  title: 'Attachment',
                  type: 'pdf',
                });
                return;
                // document.querySelector(`#image-anchor-${idx}`).click();
              }
            } catch (e) {
              console.Error('Error in opening file ', e);
            }

            // }
          }}
        >
          {false ? (
            <AttachmentImgIcon src={fileUrl} />
          ) : (
            <img
              src={pdfIcon}
              style={{ height: '32px', width: '32px' }}
              alt="pdf"
            />
          )}
          <AttachmentTextContainer>
            <AttachmentName>{fileName}</AttachmentName>
            <AttachmentDate>{uploadedOn}</AttachmentDate>
          </AttachmentTextContainer>
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            id={`image-anchor-${idx}`}
            style={{ display: 'none' }}
          />
        </AttachmentItemContainer>
      );
    };
    const renderPrescription = (ele, idx) => {
      const { openPrescription } = this.state;
      const renderDrug = (drug, idx) => (
        <MedicineContainer key={idx}>
          <SymptomIcon src={medicine} />
          <AttachmentTextContainer>
            <SymptomText>{drug.drugName}</SymptomText>
            {drug.drugLabel && <SymptomTag>{drug.drugLabel}</SymptomTag>}
          </AttachmentTextContainer>
        </MedicineContainer>
      );
      const renderLab = (lab, idx) => (
        <SymptomContainer key={idx}>
          <SymptomIcon src={labsIcon} />
          <LabTestText>{lab}</LabTestText>
        </SymptomContainer>
      );
      return (
        <CategoryContainer key={ele.prescriptionId}>
          <PrescriptionHeader>
            <PrescriptionTitle>
              <PrescriptionTitleContainer>
                <PrescriptionTitleText>Prescription</PrescriptionTitleText>
              </PrescriptionTitleContainer>
            </PrescriptionTitle>

            <DownloadContainer
              onTap={() => {
                this.props.openFileViewer({
                  contentUrl: ele.prescriptionUrl,
                  title: 'Prescription',
                  type: 'pdf',
                });
                this.setState({
                  prescriptionModal: true,
                  prescriptionLink: ele.prescriptionUrl,
                });
              }}
            >
              <DownloadText>Download</DownloadText>
              <DownloadIcon src={downloadIcon} />
            </DownloadContainer>
            {/* <a
              href={ele.prescriptionUrl}
              target="_blank"
              rel="noopener noreferrer"
              id={`prescription-${ele.prescriptionId}`}
              style={{ display: 'none' }}
            /> */}
          </PrescriptionHeader>
          <DetailHeaderText>Probable Diagnosis</DetailHeaderText>
          <SymptomContainer>
            <img src={diagnostics} alt="diagnosis" />
            <div className="ml-2">
              <SymptomText>{ele.diagnosis}</SymptomText>
            </div>
          </SymptomContainer>

          {openPrescription === idx && (
            <>
              {ele.drugs.length > 0 && ele.drugs[0].drugName && (
                <div
                  className="flex flex-col"
                  style={{
                    marginLeft: '16px',
                    marginTop: '16px',
                    marginRight: '16px',
                    borderBottom: `${
                      ele.labs.length > 0 ? '1px' : '0px'
                    } solid #F0F3F6`,
                    paddingBottom: '16px',
                  }}
                >
                  <MedicineHeader isBorderVisibile={true}>
                    Medicines
                  </MedicineHeader>
                  {ele.drugs.map(renderDrug)}
                </div>
              )}
              {ele.labs.length > 0 && (
                <>
                  <DetailHeaderText>Lab tests</DetailHeaderText>
                  {ele.labs.map(renderLab)}
                </>
              )}
              {ele.advices.length > 0 && (
                <GeneralAdviceContainer>
                  <GenralAdviceHeader>General Advice</GenralAdviceHeader>
                  <GeneralAdviceTextContainter>
                    {ele.advices.map((ele, idx) => (
                      <GenralAdvicePoint key={idx} isFirst={idx === 0}>
                        {ele}
                      </GenralAdvicePoint>
                    ))}
                  </GeneralAdviceTextContainter>
                </GeneralAdviceContainer>
              )}
            </>
          )}
          <ShowLessContainer
            onClick={() => {
              openPrescription === idx
                ? this.setState({ openPrescription: -1 })
                : this.setState({
                    openPrescription: idx,
                  });
            }}
          >
            <span>{openPrescription === idx ? 'Show Less' : 'Show All'}</span>
            {openPrescription === idx ? <ArrowUp /> : <ArrowDown />}
          </ShowLessContainer>
        </CategoryContainer>
      );
    };
    if (!consultationSummary) {
      return <LoadingComponent />;
    }
    const { symptoms, attachments, prescriptions } = consultationSummary;
    const noSummary =
      symptoms.length === 0 &&
      attachments.length === 0 &&
      prescriptions.length === 0;
    return (
      <OuterContainer>
        {noSummary ? (
          <EmptyContainer>
            <EmptyIcon src={noCasefileIcon} />
            <EmptyTitle>No Symptoms added yet!</EmptyTitle>
            <EmptySubtitle>
              Our doctor will call you and create a case summary for this
              consultation
            </EmptySubtitle>
          </EmptyContainer>
        ) : (
          <>
            {consultationSummary.symptoms.length > 0 && (
              <CategoryContainer>
                <CategoryTitle>Symptoms</CategoryTitle>
                {consultationSummary.symptoms.map(renderSymptom)}
              </CategoryContainer>
            )}
            {consultationSummary.attachments.length > 0 && (
              <CategoryContainer>
                <CategoryTitle>Attachments</CategoryTitle>
                <AttachmentsContainer>
                  {consultationSummary.attachments.map(renderAttachment)}
                </AttachmentsContainer>
              </CategoryContainer>
            )}
            {consultationSummary.prescriptions.length !== 0 &&
              consultationSummary.prescriptions.map(renderPrescription)}
          </>
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  consultationSummary: state.chat.consultationSummary,
  sponsorId: state.user.sponsorId,
});
const mapDispatchToProps = (dispatch) => ({
  openFileViewer: (content) => dispatch(openFileViewer(content)),
  getConsultationSummary: () => dispatch(getConsultationSummary()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsultationSummary);
